import { render, staticRenderFns } from "./EditResaleStock.vue?vue&type=template&id=4a3cf46c&scoped=true"
import script from "./EditResaleStock.vue?vue&type=script&lang=js"
export * from "./EditResaleStock.vue?vue&type=script&lang=js"
import style0 from "./EditResaleStock.vue?vue&type=style&index=0&id=4a3cf46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3cf46c",
  null
  
)

export default component.exports